



































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import container from "../../inversify.config";
import Loader from "@/components/Loader.vue";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { EnquiryType } from "../../enums/EnquiryType";
import { formatService } from "../../services/format.service";

const ContentSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader
  }
})
export default class ContentSetEnquiry extends Vue {
  @ContentSetModule.Action public addContentSetEnquiryType;
  @ContentSetModule.Action public removeContentSetEnquiryType;

  get getContentSet(): IContentSet {
    return this.contentSet;
  }

  get loadingStatus(): boolean {
    return this.loading || this.internalLoading;
  }

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop() public contentSet: IContentSet;
  @Prop() public loading: boolean;

  @Provide() public items: any[] = [];

  @Provide()
  public columns = [
    {
      key: "text",
      label: "Enquiry Type"
    },
    {
      key: "actions",
      label: "Delete",
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  @Provide() public selected: EnquiryType | null = null;

  @Provide() public options: any[] = [];

  private show: boolean = false;

  private selectedEnquiryType: number;

  private internalLoading: boolean = false;

  @Watch("getContentSet", { deep: true })
  public onContentSetUpdate() {
    this.getEnquiryOptions();
    this.getSelectedEnquries();
  }

  public showModal(enquiryType: number) {
    this.selectedEnquiryType = enquiryType;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public getEnquiryOptions() {
    this.selected = null;
    let enquiryOptions = this.getAllEnquiryOptions();

    const selectedEnquries = this.contentSet.enquiryTypes;

    enquiryOptions = enquiryOptions.filter(
      (x) => !selectedEnquries.includes(x.value) && x.value !== 0
    );

    this.options = enquiryOptions;
  }

  public getSelectedEnquries() {
    const enquiryOptions = this.getAllEnquiryOptions();

    const selectedEnquries = this.contentSet.enquiryTypes;

    this.items = enquiryOptions.filter(
      (x) => selectedEnquries.includes(x.value) && x.value !== 0
    );
  }

  public addEnquiry() {
    if (this.selected) {
      this.addContentSetEnquiryType(this.selected);
    }
  }

  public removeEnquiry() {
    if (this.selectedEnquiryType) {
      this.removeContentSetEnquiryType(this.selectedEnquiryType).then(
        (result) => {
          if (result) {
            this.show = false;
            this.getEnquiryOptions();
          }
        }
      );
    }
  }

  public created() {
    this.getEnquiryOptions();
  }

  private getAllEnquiryOptions() {
    const enquiryOptions = Object.keys(EnquiryType)
      .filter((k) => typeof EnquiryType[k as any] === "number")
      .map((key) => ({
        value: EnquiryType[key],
        text: formatService.camelCaseToSentenceCase(key)
      }));
    return enquiryOptions;
  }
}
